import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, FormControl, NativeSelect, Tabs, Tab, Typography, Menu, MenuItem, SelectChangeEvent, IconButton } from '@mui/material';
import styles from './ListFormularioPeticao.module.css';
// import cadastroUnicoPeticaoService from './service/formularioPeticao.service';
import { telefoneMascara, telefoneSemMascara, dataBr, cpfMascara } from '../../util/mascaras';
import VisibilityIcon from '@mui/icons-material/Visibility';
import formularioPeticaoService from './service/formularioPeticao.service';
import Head from '../../helper/Head';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Loading from '../../components/Loading/Loading';
import { useForm } from 'react-hook-form';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import ArrowRight from '@mui/icons-material/ChevronRight';


const theme = createTheme({
    palette: {
        secondary: {
            main: '#2a777a',
        },
    },
});

const ITEM_HEIGHT = 80;

export default function ListFormularioPeticao() {
    const { register, handleSubmit, watch, setValue, clearErrors, setError, formState: { errors } } = useForm();

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [statusPeticao, setStatusPeticao] = useState([] as any);
    const [listFormularioPeticao, setListFormularioPeticao] = useState([] as any);
    const [filterStatus, setFilterStatus] = useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [loadingPages, setLoadingPages] = useState(false);
    const [pagination, setPagination] = useState({} as any);
    const [page, setPage] = useState(1);
    const [previousButton, setPreviousButton] = useState(false as any);
    const [nextButton, setNextButton] = useState(false as any);


    const [estadosList, setEstadosList] = useState([] as any);
    const [estado, setEstado] = useState('');
    const [cidadesList, setCidadesList] = useState([] as any);
    const [cidade, setCidade] = useState('');

    const [estadoEscolhido, setEstadoEscolhido] = useState('');
    const [cidadeEscolhida, setCidadeEscolhida] = useState('');
    const [statusEscolhido, setStatusEscolhido] = useState(null as any);

    const [listTodosStatusDenuncia, setListTodosStatusDenuncia] = useState([] as any);

    const [anchorElEstado, setAnchorElEstado] = React.useState<null | HTMLElement>(null);
    const openEstado = Boolean(anchorElEstado);

    const handleClickEstado = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElEstado(event.currentTarget);
    };

    const handleCloseEstado = () => {
        setAnchorElEstado(null);
    };

    const [anchorElCidade, setAnchorElCidade] = React.useState<null | HTMLElement>(null);
    const openCidade = Boolean(anchorElCidade);
    const handleClickCidade = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElCidade(event.currentTarget);
    };

    const handleCloseCidade = () => {
        setAnchorElCidade(null);
    };

    const [anchorElStatus, setAnchorElStatus] = React.useState<null | HTMLElement>(null);
    const openStatus = Boolean(anchorElStatus);
    const handleClickStatus = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElStatus(event.currentTarget);
    };

    const handleCloseStatus = () => {
        setAnchorElStatus(null);
    };

    useEffect(() => {
        listStatusPeticao();
        listTodosStatusDenuncias();
    }, []);

    useEffect(() => {
        listFormulariosPeticao({ 'page': 1, 'status': filterStatus });
        setLoadingPages(true);
        setPage(1);
        setEstadoEscolhido('');
        setCidadeEscolhida('');
        setStatusEscolhido(null);

    }, [filterStatus]);

    useEffect(() => {
        listFormulariosPeticao({ 'page': page, 'status': filterStatus, 'estado': estadoEscolhido, 'cidade': cidadeEscolhida, 'status_acompanhamento': statusEscolhido });
    }, [page]);


    useEffect(() => {
        fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
            .then((response) => response.json())
            .then((data) => setEstadosList(data));
    }, []);

    useEffect(() => {
        if (!!estado)
            fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado}/municipios?orderBy=nome`)
                .then((response) => response.json())
                .then((data) => setCidadesList(data));

    }, [estado, listFormularioPeticao]);

    const listTodosStatusDenuncias = async () => {
        const resp = await formularioPeticaoService.listTodosStatusDenuncias();
        setListTodosStatusDenuncia(resp);
    }

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const listStatusPeticao = async () => {
        const resp = await formularioPeticaoService.listStatusPeticao();
        setStatusPeticao(resp);
    }

    const listFormulariosPeticao = async (params: any) => {
        setLoading(true);
        const resp = await formularioPeticaoService.listFormularios(params);
        // console.log("resp:", resp.formularios);

        setTimeout(() => {
            setNextButton(resp.pagination.links.next ? true : false);
            setPreviousButton(resp.pagination.links.previous ? true : false);
            const formularios = Array.isArray(resp.formularios)
                ? [...resp.formularios]
                : Object.values(resp.formularios || {});
            formularios.sort((a: any, b: any) => Number(b.idFormularioPeticao) - Number(a.idFormularioPeticao));
            setListFormularioPeticao(formularios);
            setPagination(resp.pagination);
            setLoading(false);
            setLoadingPages(false);
        }, 700)
    };

    const handleStatusChange = (event: any, status: any = 0) => {
        let status_id = event.target.value;

        if (status !== 0)
            status_id = status;

        setFilterStatus(status_id);
    };

    const handleChangeEstado = async (event: SelectChangeEvent) => {
        handleCloseEstado();
        setCidadeEscolhida('');
        let estado = '';

        setEstado(event.target.value);

        estadosList.forEach((e: any) => {
            if (e.id == event.target.value) {
                estado = e.nome;
                setEstadoEscolhido(e.nome);
            }
        });

        listFormulariosPeticao({ 'page': 1, 'status': filterStatus, 'estado': estado, 'cidade': '', 'status_acompanhamento': statusEscolhido });
    };

    const handleChangeCidade = async (event: SelectChangeEvent) => {
        handleCloseCidade();

        let cidade = ''

        setCidade(event.target.value);
        cidadesList.forEach((e: any) => {
            if (e.id == event.target.value) {
                cidade = e.nome
                setCidadeEscolhida(e.nome);
            }
        });

        listFormulariosPeticao({ 'page': 1, 'status': filterStatus, 'estado': estadoEscolhido, 'cidade': cidade, 'status_acompanhamento': statusEscolhido });
    };

    const handleLimpaFiltroEstadoCidade = async () => {
        handleCloseEstado();
        setLoading(true);
        setEstado('');
        setCidadesList([])

        listFormulariosPeticao({ 'page': 1, 'status': filterStatus, 'estado': '', 'cidade': '', 'status_acompanhamento': statusEscolhido });
    }

    const handleLimpaStatus = async () => {
        handleCloseStatus();
        setLoading(true);

        setStatusEscolhido(null);
        listFormulariosPeticao({ 'page': 1, 'status': filterStatus, 'estado': estadoEscolhido, 'cidade': cidadeEscolhida });
    }

    const handleChangeStatus = async (event: SelectChangeEvent) => {
        handleCloseStatus();
        setStatusEscolhido(event.target.value);

        listFormulariosPeticao({ 'page': 1, 'status': filterStatus, 'estado': estadoEscolhido, 'cidade': cidadeEscolhida, 'status_acompanhamento': event.target.value });
    }

    const changePage = (page_index: any) => {
        setNextButton(page_index == pagination.totalPages ? false : true);
        setPreviousButton(page_index == 1 ? false : true);
        setPage(page_index);
    }


    const Estados = () => {
        return (
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorElEstado}
                open={openEstado}
                onClose={handleCloseEstado}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
                <MenuItem value={0} onClick={handleLimpaFiltroEstadoCidade}>Todos</MenuItem>
                {(!!estadosList) ?
                    estadosList.map((option: any, i: any) => (
                        <MenuItem value={option.id} key={i} onClick={(e: any) => handleChangeEstado(e)}>{option.nome}</MenuItem>
                    )) : <MenuItem value={0}>Nada a ser exibido</MenuItem>
                }
            </Menu>
        )
    }

    const Cidades = () => {
        return (
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorElCidade}
                open={openCidade}
                onClose={handleCloseCidade}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
                {(!!cidadesList && cidadesList.length > 0) ?
                    cidadesList.map((option: any, i: any) => (
                        <MenuItem value={option.id} key={i} onClick={(e: any) => handleChangeCidade(e)}>{option.nome}</MenuItem>
                    )) : <MenuItem value={0} onClick={handleCloseCidade}>Escolha um estado</MenuItem>
                }
            </Menu>
        )
    }

    const Status = () => {
        return (
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorElStatus}
                open={openStatus}
                onClose={handleCloseStatus}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '40ch',
                    },
                }}
            >
                <MenuItem value={0} onClick={handleLimpaStatus}>Todos</MenuItem>
                {(!!listTodosStatusDenuncia && listTodosStatusDenuncia.length > 0) &&
                    listTodosStatusDenuncia.map((option: any, i: any) => (
                        <MenuItem value={option.id} key={i} onClick={(e: any) => handleChangeStatus(e)}>{option.name}</MenuItem>
                    ))
                }
            </Menu>
        )
    }

    return (
        <section className={`animeRight container-internal ${styles.listPeticaoSection}`}>
            <Head title=" | Listagem Petições" />
            <Card>
                <CardContent>
                    <div className={styles.cardContent}>
                        <h3 className="section-title">Listagem de Petições</h3>

                        {
                            windowWidth > 800
                                ?
                                <div className={styles.tab}>
                                    <ThemeProvider theme={theme}>
                                        <Box sx={{ width: '100%' }}>
                                            <Tabs
                                                value={filterStatus}
                                                onChange={handleStatusChange}
                                                textColor="secondary"
                                                indicatorColor="secondary"
                                                aria-label="secondary tabs example"
                                            >
                                                {statusPeticao.length > 0 &&
                                                    statusPeticao.map((status: any, index: any) => (
                                                        <Tab key={index} value={status.id} label={status.name} />
                                                    ))
                                                }
                                            </Tabs>
                                        </Box>
                                    </ThemeProvider>
                                </div>
                                :
                                <div className={styles.selectTab}>
                                    <Box sx={{ minWidth: 120 }}>
                                        <FormControl fullWidth>
                                            <NativeSelect
                                                defaultValue={filterStatus}
                                                onChange={handleStatusChange}
                                            >
                                                {statusPeticao.length > 0 &&
                                                    statusPeticao.map((status: any, index: any) => (
                                                        <option key={index} value={status.id}>{status.name}</option>
                                                    ))
                                                }
                                            </NativeSelect>
                                        </FormControl>
                                    </Box>
                                </div>
                        }

                        <div className={styles.tablePeticoes}>
                            <table className={`table table-bordered`} border={1}>
                                <thead>
                                    <tr>
                                        <th scope="col">N° Registro</th>
                                        <th scope="col">Nome</th>
                                        <th scope="col">Documento Pessoal</th>
                                        <th scope="col">
                                            Estado
                                            <IconButton onClick={handleClickEstado}>
                                                <FilterAltIcon />
                                            </IconButton>
                                            <Estados />
                                        </th>
                                        <th scope="col">
                                            Cidade
                                            <IconButton onClick={handleClickCidade}>
                                                <FilterAltIcon />
                                            </IconButton>
                                            <Cidades />
                                        </th>
                                        <th scope="col">Data da Violação</th>
                                        <th scope="col">
                                            Status
                                            {filterStatus != 4 &&
                                                <>
                                                    <IconButton onClick={handleClickStatus}>
                                                        <FilterAltIcon />
                                                    </IconButton>
                                                    <Status />
                                                </>
                                            }
                                        </th>
                                        <th scope="col">Aberto processo?</th>
                                        <th scope="col">Visualizar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ?
                                        <tr>
                                            <td colSpan={9} className={styles.noResults}>
                                                <Loading isLoading={loading} />
                                            </td>
                                            <td style={{ display: 'none' }}>
                                            </td>
                                        </tr>
                                        :
                                        (listFormularioPeticao.length > 0 ?
                                            listFormularioPeticao.map((e: any, i: any) =>
                                            (
                                                (e.idStatusDenuncia == filterStatus || filterStatus == 4) &&
                                                <tr key={i}>
                                                    <td>{e.registroDenuncia}</td>
                                                    <td>{e.nome}</td>
                                                    <td>{e.documentoPessoal}</td>
                                                    <td>{e.estadoUsuario}</td>
                                                    <td>{e.cidadeUsuario}</td>
                                                    <td>{dataBr(e.dataViolacao)}</td>
                                                    <td>{e.status_acompanhamento.name}</td>
                                                    <td>{e.nr_processo_sei == null ? 'Não' : 'Sim'}</td>
                                                    <td>
                                                        <span title="Visualizar denúncia">
                                                            <Button onClick={() => navigate('/ver-formulario-peticao/' + e.idFormularioPeticao)}><VisibilityIcon /></Button>
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                            )
                                            :
                                            <tr>
                                                <td colSpan={9} className={styles.noResults}>
                                                    <p>Não há petições registradas nos sistema.</p>
                                                </td>
                                                <td style={{ display: 'none' }}>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <div className={styles.paginateSection}>
                            {loadingPages ?
                                <Loading isLoading={loadingPages} />
                                :
                                <>
                                    {pagination && previousButton &&
                                        <button onClick={() => changePage(page - 1)}>
                                            <ArrowLeft style={{ color: '#053616', fontSize: 25 }} />
                                        </button>
                                    }

                                    {pagination.links && pagination.links.pagination &&
                                        Object.entries(pagination.links.pagination).map((item: any, index: any) => (
                                            <button key={index} className={`${page == index + 1 && styles.selectedPage}`} onClick={() => changePage(index + 1)}>{index + 1}</button>
                                        ))
                                    }

                                    {pagination && nextButton &&
                                        <button onClick={() => changePage(page + 1)}>
                                            <ArrowRight style={{ color: '#053616', fontSize: 25 }} />
                                        </button>
                                    }
                                </>
                            }
                        </div>
                        <p className={styles.resultsLenght}>Exibindo {listFormularioPeticao.length} resultados de {pagination.quantity}</p>
                    </div>
                </CardContent>
            </Card>
        </section>
    )
}
